import React from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

export interface ICountProps {
  value: number;
  start?: number;
  delay?: number;
  duration?: number;
  enableScrollSpy?: boolean;
  formatRegex?: string;
}

export const Count = (props: ICountProps): JSX.Element => {
  const [isMounted, setIsMounted] = React.useState(false);

  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true
  });

  React.useEffect(() => {
    setIsMounted(true);
  }, []);

  const countUpWhenInView = (): null | React.ReactNode => {
    return inView || !props.enableScrollSpy ? (
      <>
        <CountUp end={props.value} start={props.start || 0} delay={props.delay || 0} duration={props.duration || 2} formattingFn={format}>
          {({ countUpRef }) => <span ref={countUpRef} />}
        </CountUp>
      </>
    ) : null;
  };

  return (
    <>
      <span className="sr-only">{props.value}</span>
      <span ref={ref} aria-hidden={true}>
        {isMounted ? countUpWhenInView() : <span>{format(props.value, props.formatRegex)}</span>}
      </span>
    </>
  );
};

Count.defaultProps = {
  enableScrollSpy: true
};

const format = (count: number, regex?: string): string => {
  return count.toString().replace(regex || /\B(?=(\d{3})+(?!\d))/g, ' ');
};
